<template>
  <div class="gamecontent">
    <template v-if="($route.query.type ==  1)">
      <Champoin :score_list="score_list" :tab_list="tab_list" :sel_list="sel_list"></Champoin>
    </template>
    <template v-if="($route.query.type ==  2)">
      <ScoreGuessing :score_list="score_list" :tab_list="tab_list"></ScoreGuessing>
    </template>
    <template v-if="($route.query.type ==  3)">
      <GoalGuessing :score_list="score_list" :tab_list="tab_list" :radioin="radioin"></GoalGuessing>
    </template>
    <template v-if="($route.query.type ==  4)">
      <GroupStage :score_list="score_list" :tab_list="tab_list"></GroupStage>
    </template>
    <template v-if="($route.query.type ==  5)">
      <TeamScore :score_list="score_list" :tab_list="tab_list"></TeamScore>
    </template>
  </div>
</template>

<script>
    import Champoin from '../components/Champion'
    import ScoreGuessing from '../components/ScoreGuessing'
    import GoalGuessing from '../components/GoalGuessing'
    import GroupStage from '../components/GroupStage'
    import TeamScore from '../components/TeamScore'

    export default {
        name: "GameContent",
        components: {
            Champoin,
            ScoreGuessing,
            GoalGuessing,
            GroupStage,
            TeamScore
        },
        data() {
            return {
                score_list: [],
                tab_list: [],
                sel_list: [],
                radioin:'',
            }
        },
        mounted() {
            this.$axios.all([this.getAllTask(this.$route.query.id), this.getAllCity(this.$route.query.id)])
                .then(this.$axios.spread((allTask, allCity) => {
                    this.score_list = allTask.data.data;
                    console.log(this.score_list);
                    this.tab_list = allCity.data.data;
                    console.log(this.tab_list)
                    for (let i = 0;i<this.tab_list.length;i++){
                        this.getSelctList(this.tab_list[i].id)
                        // console.log(this.tab_list[i].id)
                    }
                }))
        },
        methods: {
            getSelctList(id) {
                if (this.$route.query.type != 1){
                    return
                }
                this.$axios({
                    url: 'https://api.hainanfa.org.cn/guess/Get_Guess_Item_Choose_select',
                    method: 'post',
                    params: {
                        choose_id: id
                    },
                    headers:{
                        'Content-Type':'application/json;charset=utf-8'
                    }
                }).then(res => {
                    this.sel_list.push(res.data.data);
                    // console.log(this.sel_list)
                }).catch(err => {
                    console.log(err);
                })
            },
            getAllTask: function (id) {
                return this.$axios({
                    url: 'https://api.hainanfa.org.cn/guess/Get_Guess_Item_Detail',
                    method: 'post',
                    params: {
                        id: id,
                        user_id:localStorage.getItem("id"),
                    },
                    headers:{
                        'Content-Type':'application/json;charset=utf-8'
                    }
                })
            },
            getAllCity: function (id) {
                return this.$axios({
                    url: 'https://api.hainanfa.org.cn/guess/Get_Guess_Item_Choose',
                    method: 'post',
                    params: {
                        item_id: id
                    },
                    headers:{
                        'Content-Type':'application/json;charset=utf-8'
                    }
                })
            },

        },
    }
</script>

<style scoped>
  .gamecontent {
    padding: 20px 10px;
    padding-bottom: 50px;
  }
</style>
